module.exports = "/assets/data/95f3dfb415d501ecfede7644ccd88c82-G61.data.json";